import { render, staticRenderFns } from "./upload-statistics.vue?vue&type=template&id=1a11cb78&scoped=true&"
import script from "./upload-statistics.ts?vue&type=script&lang=ts&"
export * from "./upload-statistics.ts?vue&type=script&lang=ts&"
import style0 from "./upload-statistics.scss?vue&type=style&index=0&id=1a11cb78&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a11cb78",
  null
  
)

export default component.exports